var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCut(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17804",
    d: "M0 0h20v20H0z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17805",
    d: "M8.367 6.7a3.247 3.247 0 0 0 .3-1.367 3.333 3.333 0 1 0-3.334 3.334 3.247 3.247 0 0 0 1.367-.3l1.967 1.967L6.7 12.3a3.247 3.247 0 0 0-1.367-.3 3.333 3.333 0 1 0 3.333 3.333 3.247 3.247 0 0 0-.3-1.367L10.333 12l5.833 5.833h2.5V17zM5.333 7A1.667 1.667 0 1 1 7 5.333 1.666 1.666 0 0 1 5.333 7zm0 10A1.667 1.667 0 1 1 7 15.333 1.666 1.666 0 0 1 5.333 17zm5-6.25a.417.417 0 1 1 .417-.417.413.413 0 0 1-.417.417zm5.833-7.917-5 5L12.833 9.5l5.833-5.833v-.834z",
    transform: "translate(-.333 -.333)",
    style: {
      fill: "#484848"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCut);
export default __webpack_public_path__ + "static/media/cut.864ddf48f31664fb7bf55d988b58c13f.svg";
export { ForwardRef as ReactComponent };